import Image from 'next/image';
import {useEffect} from 'react';

import TopAuction from '@components/dropAuction/topAuction/topAuction';
import styles from '@styles/retailers/retailers.module.scss';

const RetailesPage = () => {
	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://js.hsforms.net/forms/embed/v2.js';
		document.body.appendChild(script);

		script.addEventListener('load', () => {
			if (window.hbspt) {
				window.hbspt.forms.create({
					region: 'na1',
					portalId: '47537090',
					formId: '0f3e777b-a164-4971-9d76-1e865065f09a',
					target: '#hubspotFormGetInTouch',
					onFormReady: form => {
						customizeHubSpotForm(form);
					},
				});
			}
		});

		const customizeHubSpotForm = form => {
			const submitButton = form.querySelector('input[type="submit"]');
			if (submitButton) {
				submitButton.style.marginTop = '-30px';
			}

			const viralityLink = form.querySelector('.hs-form__virality-link');
			if (viralityLink) viralityLink.remove();
		};
	}, []);
	return (
		<div>
			<div className='headingSectionTwo'>
				<h1>YOU IMPROVE YOUR SALES MARGINS</h1>
			</div>
			<div className={styles.topContainer}>
				<div className={styles.topContainerImageContainer}>
					<div className={styles.topContainer__Image}>
						<Image
							alt='dollar sign'
							height='501'
							width='261'
							src={'/img/dollar-sign.png'}
						/>
					</div>
				</div>
				<div className={styles.topContainer__Right}>
					<div className={styles.topContainer__RightInner}>
						<p>
							Better That Drop Auctions also provide you with a way to clear
							stock easily and{' '}
							<span>
								help break the cycle of endless promotions and fixed priced
								discounting.
							</span>{' '}
							Ultimately, improving your sales margins.
						</p>

						<p>
							Easy and quick to set up via your very own portal access,{' '}
							<span>you remain in complete control.</span>
						</p>
					</div>

					<div>
						<p>You Determine</p>
						<ul>
							<li>
								the items you sell, whether one SKU (e.g. defined by individual
								variable such as color or size) or scalable right up to an
								entire product range;
							</li>
							<li>the lowest price you’re willing to sell the items for</li>
							<li>the quantities you’d like to sell;</li>
							<li>when the Drop Auction runs</li>
							<li>how many Drop Auctions you run.</li>
						</ul>
					</div>
				</div>
			</div>
			<div className={styles.listDropSection}>
				<div className={styles.listDropSectionContent}>
					<h2>LIST DROP AUCTIONS ON OUR WEBSITE</h2>
					<p>
						Partner with us as a retailer and you can list the Drop Auctions on
						our website.
					</p>
					<p>
						This also provides you with an opportunity to{' '}
						<span>
							reach, engage and pick up new shoppers who may be exploring our
							catalogue of Upcoming Auctions.
						</span>
					</p>
					<p>TRAIL RUN IS IN PROGRESS!!</p>
					<p>
						LAUNCH TO MARKET IN <span>JUNE 2025</span>
					</p>
				</div>
				<div className={styles.dropAuctionContainer}>
					{/* <div className={styles.dropAuctionContainerGrid}>
						<TopAuction limit={2} />
					</div> */}
					<div className='p-3' id='hubspotFormGetInTouch'></div>
				</div>
			</div>
		</div>
	);
};

RetailesPage.Layout = true;
export default RetailesPage;
